<template>
	<div class="grid-content">
		<div class="date_search">
			<div class="search">
				<el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 100%;"
					:picker-options="pickerOptions" @change="searchChange">
				</el-date-picker>
			</div>
			<div class="driver">
				<el-select v-model="query.driver" size="small" filterable placeholder="请选择" @change="searchChange">
					<el-option v-for="item in driverOptions" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="sx">
				<div @click="sxDate(1)">7天</div>
				<div @click="sxDate(2)">30天</div>
				<div @click="sxDate">清空</div>
			</div>
		</div>
		<div class="chart">
			<fieldset v-loading="loading">
				<div style="width: 100%;height:18.75rem;" ref="driver_chart"></div>
			</fieldset>
		</div>
		<div class="list" v-if="!loading && list.length>0">
			<el-row :gutter="20">
				<el-col :span="21">
					<el-table :data="list" border style="width: 100%">
						<el-table-column width="120" label="日期">
							<template slot-scope="scope">
								{{scope.row.date}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="司机">
							<template slot-scope="scope">
								{{scope.row.name}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="订单量">
							<template slot-scope="scope">
								<span class="link" @click="lookOrder(scope.$index)">{{ scope.row.order }}</span>
								<span>笔</span>
							</template>
						</el-table-column>
						<el-table-column align="center" label="营业额">
							<template slot-scope="scope">
								{{ scope.row.amount }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="实际收益">
							<template slot-scope="scope">
								{{ scope.row.actual }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="未结收益">
							<template slot-scope="scope">
								<span v-if="scope.row.notactual!='0.00'"
									style="color: red;">{{ scope.row.notactual }}</span>
								<span v-else>{{ scope.row.notactual }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" label="信息费">
							<template slot-scope="scope">
								{{ scope.row.take }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="线上支付">
							<template slot-scope="scope">
								{{ scope.row.commission }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="线下结单">
							<template slot-scope="scope">
								{{ scope.row.coupon }}
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="3">
					<el-link v-if="downurl" target="_blank" :href="downurl" :underline="false"
						style="margin-left:0.9375rem;">
						<el-button type="success">导出数据</el-button>
					</el-link>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	var driverChart;
	export default {
		data() {
			return {
				loading: true,
				query: {
					date: [],
					driver: ""
				},
				pickerOptions: {
					disabledDate: (time) => {
						const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
						return time.getTime() > newDate;
					}
				},
				driverOptions: [],
				downurl: null,
				list: []
			};
		},
		mounted() {
			driverChart = echarts.init(this.$refs.driver_chart);
			this.initDate();
		},
		methods: {
			sxDate(t = 0) {
				const end = new Date();
				const start = new Date();
				switch (t) {
					case 1:
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
						this.query.date = [this.$formatDay(start), this.$formatDay(end)];
						if (this.query.date != null && this.query.driver > 0) {
							this.postTotal();
						}
						break;
					case 2:
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
						this.query.date = [this.$formatDay(start), this.$formatDay(end)];
						if (this.query.date != null && this.query.driver > 0) {
							this.postTotal();
						}
						break;
					default:
						this.initDate();
				}
			},
			initDate() {
				const end = new Date();
				const start = new Date();
				this.query.date = [this.$formatDay(start), this.$formatDay(end)];
				this.query.driver = "";
				this.postTotal();
			},
			searchChange(e) {
				const that = this;
				if (that.query.date != null && that.query.driver > 0) {
					that.postTotal();
				}
			},
			onDriverEcharts(boolean) {
				const that = this;
				var name = [],
					order = [];
				var list = that.list;
				for (var i = 0; i < list.length - 1; i++) {
					if (list[i].order > 0) {
						if (boolean) {
							name.push(list[i].date);
						} else {
							name.push(list[i].name);
						}
						order.push(list[i].order);
					}
				}
				driverChart.setOption({
					color: ["#3fb1e4"],
					title: {
						text: '订单走势',
						textStyle: {
							fontSize: 17,
							color: "#000"
						}
					},
					tooltip: {},
					xAxis: {
						data: name
					},
					yAxis: {},
					series: [{
						name: '订单量',
						type: 'bar',
						data: order
					}]
				});
			},
			lookOrder(index) {
				const that = this;
				let list = that.list;
				let did = that.list[index].id;
				if (did == undefined) {
					if (that.query.driver == "") {
						that.$router.push({
							name: "order_list_all",
							params: {
								query: {
									date: that.query.date
								}
							}
						});
					} else {
						that.$router.push({
							name: "order_list_all",
							params: {
								query: {
									keytype: "name",
									keyword: that.list[0].name,
									date: that.query.date
								}
							}
						});
					}
				} else {
					let name = that.list[index].name;
					let date = that.list[index].date;
					that.$router.push({
						name: "order_list_all",
						params: {
							query: {
								keytype: "name",
								keyword: name,
								date: [date, date]
							}
						}
					});
				}
			},
			postTotal() {
				const that = this;
				that.loading = true;
				that.$post('totalDriver', {
					date: that.query.date,
					driver: that.query.driver
				}).then(res => {
					const driverOptions = [];
					setTimeout(function() {
						that.loading = false;
						that.list = res.data.list;
						that.driverOptions = res.data.search;
						if (that.query.driver > 0) {
							that.onDriverEcharts(true);
						} else {
							that.onDriverEcharts(false);
						}
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.chart fieldset {
		margin: 0;
		padding: 1.25rem 1.25rem 2rem;
		border: 1px #e6e6e6 solid;
	}

	.list {
		margin: 1.25rem 0;
	}

	.list>>>.el-table__body .el-table__row:last-child {
		font-weight: bold;
		background-color: #f2f5f9;
	}
</style>
